import React, { useContext } from 'react';
import { navigate } from '@reach/router';
import { FormikHelpers } from 'formik';
import { useApiRequest } from '../../../api/useApiRequest';
import { RouteComponentProps } from '../../../helpers/RouteComponentProps';
import { PageContainer } from '../../../layout/Layout';
import { Header1 } from '../../../shared/Headers';
import { HandoverPackSectionContext } from '../documents-section/HandoverPackSectionContext';
import { handoverPackSectionsRoot } from '../documents-section/documentRoutes';
import { CreateOrUpdateHandoverPackSectionForm } from './CreateOrUpdateHandoverPackSectionForm';
import { HandoverPackSectionFormModel, initialHandoverPackSectionFormModel } from './handoverPackSectionFormModel';

type CreateHandoverPackSectionComponents = (props: RouteComponentProps) => JSX.Element | null;

export const CreateHandoverPackSection: CreateHandoverPackSectionComponents = () => {
  const createHandoverPackSectionEndpoint = 'handover-pack/section/create';

  const { error, sendRequest } = useApiRequest<undefined, HandoverPackSectionFormModel>({
    endpointUrl: createHandoverPackSectionEndpoint,
    httpMethod: 'post',
  });

  const { refreshContext } = useContext(HandoverPackSectionContext);

  const onSubmit = (
    formModel: HandoverPackSectionFormModel,
    formikHelpers: FormikHelpers<HandoverPackSectionFormModel>,
  ) => {
    void sendRequest({
      requestBody: formModel,
      onSuccess: async () => {
        formikHelpers.setSubmitting(false);
        refreshContext();
        await navigate(handoverPackSectionsRoot);
      },
      onFailure: () => {
        formikHelpers.setSubmitting(false);
        formikHelpers.setStatus('Failed');
      },
    });
  };

  return (
    <PageContainer>
      <Header1>Create Handover Pack Section</Header1>
      <CreateOrUpdateHandoverPackSectionForm
        initialValues={initialHandoverPackSectionFormModel}
        onSubmit={onSubmit}
        error={error}
      />
    </PageContainer>
  );
};
